import React,{useId} from 'react';
import {useLang} from './i18n';
import {HoverTip} from './HoverTip';
// MALVO team, developer and moderator badges shown right of a member's name (like Discord's staff badge).
export function StaffMark({person,size=16}:{person:any;size?:number}){
 const [,,tr]=useLang();
 // Per badge: with a shared id, a hidden badge earlier on the page takes the colour from all others.
 const gradient=useId(),developerGradient=useId(),moderatorGradient=useId();
 if(!person?.staff&&!person?.malvoDeveloper&&!person?.malvoModerator)return null;
 const label=tr('MALVO Team','MALVO-Team');
 return <>{person.staff&&<HoverTip className="staff-mark" label={label}>
  <svg viewBox="0 0 24 24" width={size} height={size}>
   <defs><linearGradient id={gradient} x1="0" y1="0" x2="1" y2="1"><stop offset="0" stopColor="#ff6b6b"/><stop offset="1" stopColor="#c81e3a"/></linearGradient></defs>
   <path fill={`url(#${gradient})`} d="M12 1.5 20.5 4.6v6.2c0 5.3-3.6 9.8-8.5 11.7C7.1 20.6 3.5 16.1 3.5 10.8V4.6z"/>
   <path fill="#fff" d="M7.2 16V8.2h2l2.8 4 2.8-4h2V16h-2.2v-4.4L12 15.2l-2.6-3.6V16z"/>
  </svg>
 </HoverTip>}{person.malvoDeveloper&&<HoverTip className="staff-mark" label="MALVO Developer">
  <svg viewBox="0 0 24 24" width={size} height={size}>
   <defs><linearGradient id={developerGradient} x1="0" y1="0" x2="1" y2="1"><stop offset="0" stopColor="#60a5fa"/><stop offset="1" stopColor="#2563eb"/></linearGradient></defs>
   <path fill={`url(#${developerGradient})`} d="M12 1.5 20.5 4.6v6.2c0 5.3-3.6 9.8-8.5 11.7C7.1 20.6 3.5 16.1 3.5 10.8V4.6z"/>
   <path fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" d="M9.4 8.6 6.6 11.7l2.8 3.1M14.6 8.6l2.8 3.1-2.8 3.1"/>
  </svg>
 </HoverTip>}{person.malvoModerator&&<HoverTip className="staff-mark" label="MALVO Moderator">
  <svg viewBox="0 0 24 24" width={size} height={size}>
   <defs><linearGradient id={moderatorGradient} x1="0" y1="0" x2="1" y2="1"><stop offset="0" stopColor="#34d399"/><stop offset="1" stopColor="#059669"/></linearGradient></defs>
   <path fill={`url(#${moderatorGradient})`} d="M12 1.5 20.5 4.6v6.2c0 5.3-3.6 9.8-8.5 11.7C7.1 20.6 3.5 16.1 3.5 10.8V4.6z"/>
   <path fill="none" stroke="#fff" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" d="m7.8 11.8 3 3 5.4-5.8"/>
  </svg>
 </HoverTip>}</>;
}
